import { hdrm, view, customHtml } from '@yola/ws-sdk';

const { updateStrategies } = hdrm.constants;
const { TEMPLATE_TAG, RUNTIME_RENDERING_ATTRIBUTE } = customHtml.constants;

function updateContent(element, content, isRuntimeRendering) {
  const elementId = view.accessors.getLiveElementId(element);
  const newElement = element.cloneNode();
  const isContentPresent = Boolean(content.trim());

  if (isContentPresent) {
    const template = element.ownerDocument.createElement(TEMPLATE_TAG);
    template.innerHTML = content;
    newElement.appendChild(template);
  }

  if (isRuntimeRendering) {
    newElement.setAttribute(RUNTIME_RENDERING_ATTRIBUTE, '');
  } else {
    newElement.removeAttribute(RUNTIME_RENDERING_ATTRIBUTE);
  }

  const replaceOptions = { strategy: updateStrategies.UPDATE_STATIC_ONLY };

  view.operations.replaceElement(newElement, elementId, replaceOptions);
}

export default updateContent;
